import { SpaceBetween } from "@cloudscape-design/components-themed";
import { useParams } from "react-router-dom";
import ApplicationInfo from "./ApplicationInfo";
import { useEffect, useState } from "react";
import Merchant from "./Merchant";
import Store from "./Store";
import Footer from "./Footer";
import { useGetIndividualHandlingConfirmationTargetQuery } from "../../features/api";
import {
  ConfirmationStoreInfo,
  ConfirmationMerchantInfo,
} from "../../features/api-interfaces";
import { useAppSelector } from "../../app/hook";
import { isEmpty, isNull } from "lodash";
import { filteredStoreList } from "./util";

/**
 * 個別取扱確認更新
 */
const Main = () => {
  const { applicationNo } = useParams();
  const { searchCriteria } = useAppSelector(
    (state) => state.individualHandlingList
  );
  const [merchant, setMerchant] = useState<
    ConfirmationMerchantInfo | undefined
  >(undefined);
  const [storeList, setStoreList] = useState<
    ConfirmationStoreInfo[] | undefined
  >(undefined);
  const { data, refetch, isFetching } =
    useGetIndividualHandlingConfirmationTargetQuery(applicationNo as string, {
      skip: !applicationNo,
    });
  const isMerchantRegistered = isEmpty(data?.merchant)
    ? true
    : !isNull(data?.merchant.confirmationResult);
  const registeredStoreList =
    data?.storeInfoList?.filter((store) => !isNull(store.confirmationResult)) ??
    [];
  const isStoreRegistered = isEmpty(data?.storeInfoList)
    ? true
    : data!.storeInfoList.every((store) => !isNull(store.confirmationResult));
  const isIndividualConsultation = isEmpty(data?.merchant)
    ? false
    : data?.merchant.individualHandlingReason.includes("01") ?? false;

  useEffect(() => {
    refetch();
  }, [refetch]);

  useEffect(() => {
    setMerchant(data?.merchant);
    if (data?.storeInfoList && 0 < data.storeInfoList.length) {
      resetStoreList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  /**
   * APIから受け取った店舗リストを画面に表示する.
   */
  const resetStoreList = () =>
    setStoreList(filteredStoreList(data?.storeInfoList, searchCriteria));

  return (
    <SpaceBetween direction={"vertical"} size={"l"}>
      {data && (
        <ApplicationInfo
          data={data}
          isIndividualHandlingTarget={isIndividualConsultation}
        />
      )}
      {merchant && (
        <Merchant
          merchant={merchant}
          setMerchant={setMerchant}
          isMerchantRegistered={isMerchantRegistered}
          isIndividualConsultation={isIndividualConsultation}
        />
      )}
      {!isEmpty(storeList) && (
        <Store
          registeredStoreList={registeredStoreList}
          storeList={storeList ?? []}
          setStoreList={setStoreList}
          resetStoreList={resetStoreList}
        />
      )}
      <Footer
        applicationNo={applicationNo as string}
        isMerchantRegistered={isMerchantRegistered}
        merchant={merchant}
        registeredStoreList={registeredStoreList}
        storeList={storeList}
        disabledUpdateButton={
          isStoreRegistered && isMerchantRegistered && isFetching
        }
        refetch={refetch}
      />
    </SpaceBetween>
  );
};

export default Main;
